<template>
  <a v-bind="$attrs" class="em-link" :class="{'disabled': disabled, 'underlined': underlined}" @click="goTo">
    <slot />
  </a>
</template>

<script setup>
const props = defineProps({
  to: { type: String, default: '' },
  href: { type: String, default: '' },
  target: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  underlined: { type: Boolean, default: false }
})
const router = useRouter()
const goTo = () => {
  if (props.to) {
    router.push(props.to)
  } else if (props.target) {
    window.open(props.href, props.target)
  } else {
    window.location.href = props.href
  }
}
</script>

<style lang="scss" scoped>
.em-link {
  color: rgb(var(--v-theme-primary-lighten-2)) !important;
  text-decoration: none;
  cursor: pointer;
  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
  &.underlined {
    text-decoration: underline;
  }
}
</style>
